import Phaser from 'phaser';
import { SceneKeys } from './SceneKeys';

/**
 * Primera escena: configuración mínima antes de precargar/generar nada
 * (tamaño de render, redondeo de píxeles, etc.). No carga assets.
 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super(SceneKeys.Boot);
  }

  create(): void {
    this.cameras.main.setBackgroundColor('#1b1030');
    this.scene.start(SceneKeys.Preload);
  }
}
